<template>
  <actions-menu v-model:dialogEdit="editRequestDialog" v-model:dialogConsult="editRequestDialog" :Id="Id"
    v-model:dialogDelete="dialog" :ShowDialogEdit="isEditMode" :ShowDialogDelete="isEditMode"
    :ShowDialogConsult="!isEditMode" />
  <dialogDelete :title="$t('purchaseOrder.purchaseOrder')" :yes="deleteRequest" v-model="dialog" />
  <v-dialog v-model="editRequestDialog">
    <v-card width="1100px" class="py-2" style="border-radius: 12px">
      <div class="row ma-4">
        <div class="col-4 justify-content-start">
          <div class="row">
            <v-card-title class="text-left">{{ $t("Brands.Name") }}<span class="red">*</span></v-card-title>
          </div>
          <div class="row">
            <v-text-field v-model="BrandName" id="Title" name="Title" maxlength="30" hide-details persistent-placeholder
              :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Name') })
                " variant="outlined" class="rounded-xl"></v-text-field>
            <span class="warningHint" id="WarningMsgReference">{{ msg.BrandName }}</span>
          </div>
        </div>

        <div class="col-4 justify-content-start">
          <div class="row">
            <v-card-title class="text-left">{{ $t("Brands.Supplier") }}<span class="red">*</span></v-card-title>
          </div>
          <div class="row">
            <v-autocomplete :style="MySupplier ? 'pointer-events: none;' : ''" v-model="supplierId"
              @update:model-value="handleSupplierSelect" :items="suppliers" item-title="name" item-value="supplierId"
              persistent-placeholder variant="outlined" :placeholder="$t('placeholder.select', {
                itm: $t('Brands.Supplier'),
              })
                " hide-details>
              <template v-slot:item="{ props, item, index }">
                <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                  {{ item.brandName }}
                </v-list-item>
              </template>
            </v-autocomplete>
            <span class="warningHint" id="WarningMsgCompany">{{ msg.Supplier }}</span>
          </div>
        </div>

        <div class="col-4 justify-content-start">
          <div class="row">
            <v-card-title class="text-left">{{ $t("Brands.Category") }}<span class="red">*</span></v-card-title>
          </div>
          <div class="row">
            <autocompleteGrouped v-model="IdCategories" :items="flattenedCategories" :placeholder="$t('placeholder.select', {
              itm: $t('Brands.Category'),
            })
              " />
            <span class="warningHint" id="WarningMsgCompany">{{ msg.categories }}</span>
          </div>
        </div>
      </div>
      <!-- -->
      <div class="row ma-4">
        <div class="row">
          <v-card-title class="text-left">{{ $t("Brands.Description") }}</v-card-title>
        </div>
        <div class="row">
          <v-textarea id="Comment" v-model="Description" variant="outlined"
            :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Description') })" hide-details
            maxlength="500" class="py-3" rows='5' no-resize></v-textarea>
        </div>
      </div>
      <div class="row ma-4" v-if="item?.logo != 'null'">
        <div class="row">
          <v-card-title class="text-left">{{
            $t("configuration.company.logo")
          }}</v-card-title>
        </div>
        <div class="row">
          <uploadLogo :API="2" :logoUrl="initLogo" @addLogo="setLogo" :namelogo="logoImage ?? initLogo" />
        </div>
      </div>

      <card-actions :yes="updateBrand" v-model:no="editRequestDialog" :loader="loader" :yesDisable="loader"
        width="300px" :yesTitle="$t('actions.save')" />
    </v-card>
  </v-dialog>
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import dialogDelete from "@/genericComponent/dialogDelete.vue";
import cardActions from "@/genericComponent/cardActions.vue";
import uploadLogo from "@/genericComponent/uploadLogo.vue";
import autocompleteGrouped from "@/genericComponent/autocompleteGrouped.vue";
import {
  getAllCategories,
  isSupplier,
  idSupplier,
  getAllSuppliersForProducts,
  UpdateBrand,
  DeleteBrand,
} from "@/api/index";
export default {
  components: { actionsMenu, dialogDelete, cardActions, uploadLogo, autocompleteGrouped },
  props: ["idBrand", "Id", "getBrand", "getBrandListAfterDelete"],
  mounted() {
    this.IdCategories = this.getBrand.category.map((c) => c.categoryId);
    this.initLogo = this.getBrand.logoUrl !== "" ? this.getBrand.logoUrl : null;
    this.Description = this.getBrand.description;
    this.BrandName = this.getBrand.brandName;
    this.supplierId = this.getBrand.supplierDetails.supplierId;
    this.selectedSupplierName = this.getBrand.supplierDetails.supplierName;
    this.fetchCategoriesAndSuppliers();
  },
  data() {
    return {
      editRequestDialog: false,
      IdCategories: [],
      isEditMode: true,
      initLogo: null,
      logoImage: null,
      item: null,
      dialog: false,
      categories: [],
      MySupplier: null,
      Title: null,
      supplierId: null,
      selectedSupplierName: null,
      SupplierSearch: null,
      suppliers: [],
      msg: [],
      loader: false,
      Description: null,
      BrandName: null,
    };
  },
  methods: {
    handleSupplierSelect(value) {
      const selectedSupplier = this.suppliers.find(
        (supplier) => supplier.supplierId === value
      );
      if (selectedSupplier) {
        this.selectedSupplierName = selectedSupplier.name;
      }
    },
    setLogo(value) {
      this.logoImage = value;
    },

    ActiveWarningSnackBar() {
      this.getParent("MainLayout").ActiveWarningSnackBar();
    },
    ActiveSavedSnackBar() {
      this.getParent("MainLayout").ActiveSavedSnackBar();
    },
    ActiveDeletedSnackBar() {
      this.getParent("MainLayout").ActiveDeletedSnackBar();
    },
    getParent(name) {
      let p = this.$parent;
      while (typeof p !== "undefined") {
        if (p.$options.name == name) {
          return p;
        } else {
          p = p.$parent;
        }
      }
      return false;
    },
    async updateBrand() {
      this.loader = true;
      if (!this.supplierId || this.supplierId.length == 0) {
        this.msg["Supplier"] = this.$t("warningInput.isrequired", {
          itm: this.$t("Brands.Supplier"),
        });
      } else {
        this.msg["Supplier"] = "";
      }

      if (!this.BrandName || this.BrandName.length == 0) {
        this.msg["BrandName"] = this.$t("warningInput.isrequired", {
          itm: this.$t("Brands.Name"),
        });
      } else {
        this.msg["BrandName"] = "";
      }
      if (!this.IdCategories || this.IdCategories.length == 0) {
        this.msg["categories"] = this.$t("warningInput.isrequired", {
          itm: this.$t("Brands.Category"),
        });
      } else {
        this.msg["categories"] = "";
      }
      if (
        this.msg["Supplier"] == "" &&
        this.msg["BrandName"] == "" &&
        this.msg["categories"] == ""
      ) {
        let logoBlob = "";
        if (this.logoImage) {
          const fileStream = await this.logoImage.arrayBuffer();
          logoBlob = new Blob([fileStream], { type: this.logoImage.type });
        }
        UpdateBrand(
          this.idBrand,
          this.BrandName,
          this.Description,
          logoBlob,
          [...this.IdCategories],
          this.supplierId,
          this.selectedSupplierName
        )
          .then((res) => {
            this.ActiveSavedSnackBar();
            if (res.status == 200) {
              this.editRequestDialog = false;
            }
            this.getBrandListAfterDelete();
          })
          .catch((error) => {
            console.error("Error:", error);
            this.ActiveWarningSnackBar();
          });
      }
      this.loader = false;
    },
    async fetchCategoriesAndSuppliers() {
      try {
        const [categoriesResponse, suppliersResponse] = await Promise.all([
          getAllCategories(),
          getAllSuppliersForProducts(),
        ]);
        this.categories = categoriesResponse.data;
        this.suppliers = suppliersResponse.data;

        if (isSupplier()) {
          this.MySupplier = idSupplier();
          this.supplierId = this.MySupplier;
        }
      } catch (error) {
        console.error("Error fetching categories or suppliers:", error);
      }
    },
    deleteRequest() {
      this.dialog = false;
      DeleteBrand(this.idBrand)
        .then(() => {
          this.ActiveDeletedSnackBar();
          this.getBrandListAfterDelete();
        })
        .catch((error) => {
          console.error(error);
          this.ActiveWarningSnackBar();
        });
    },
  },
  computed: {
    flattenedCategories() {
      const flatten = (cats, parentId = null, level = 0) => {
        return cats.reduce((acc, category) => {
          if (category.parent_category_id === parentId) {
            const flatCategory = {
              ...category,
              name: "  ".repeat(level) + category.name,
            };
            acc.push(flatCategory);
            acc.push(...flatten(cats, category.categoryId, level + 1));
          }
          return acc;
        }, []);
      };
      return flatten(this.categories);
    },
  },
};
</script>
<style scoped>
h1 {
  font-family: inter;
  font-size: 18px;
  line-height: 29px;
  font-weight: 600;
  color: #0d0849;
  text-align: center;
}

.v-card-text {
  font-family: inter;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #768da9;
}

.rounded-table {
  border-radius: 10px;
}

.custom-divider {
  border-top: 1px solid;
  border-color: currentColor;
}

.border-right {
  border: 1px solid #ddd;
  text-align: center;
  border-style: dotted;
  padding: 2px 4px;
}

.totals {
  margin-top: 20px;
  /* font-weight: bold; */
}

.align-right {
  padding-right: 85px;
  text-align: right;
  position: relative;
}

.totals p {
  margin: 5px 0;
}

.align-devise {
  float: right;
  margin-left: -16px;
}

.v-card-title {
  font-family: inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #5b6d8e;
}

.textConsumptionThreshold {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #080c3e;
}

.customWarningHint {
  color: #f25c5c;
  padding: 12px 0px 12px 12px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 0px;
  display: block;
  text-align: left;
  text-wrap: nowrap;
}
</style>
